import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/homeView.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/homeView.vue')
  },
  {
    path: '/blogs',
    name: 'BlogsView',
    component: () => import(/* webpackChunkName: "BlogsView" */ '../views/blogs.vue')
  },
  {
    path: '/blogs/:id',
    name: 'BlogDetail',
    component: () => import(/* webpackChunkName: "BlogDetail" */ '../views/blogDetail.vue')
  },
  {
    path: '/agreement',
    name: 'AgreementView',
    component: () => import(/* webpackChunkName: "AgreementView" */ '../views/agreement.vue')
  },
  {
    path: '/joinUs',
    name: 'JoinUs',
    component: () => import(/* webpackChunkName: "JoinUs" */ '../views/joinUs.vue')
  },
  {
    path: '/safe',
    name: 'SafeView',
    component: () => import(/* webpackChunkName: "SafeView" */ '../views/safe.vue')
  },
  {
    path: '/questions',
    name: 'QuestionsView',
    component: () => import(/* webpackChunkName: "QuestionsView" */ '../views/questions.vue')
  },
  // {
  //   path: '/authorization',
  //   name: 'AuthorizationView',
  //   component: () => import(/* webpackChunkName: "AuthorizationView" */ '../views/authorization.vue')
  // },
  {
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
